
import { generateQueryParams } from 'utils/interfaces';
import CommonService from './common.service';

class UserService extends CommonService {
	async getUsers(params?: { [key: string]: string | boolean }) {
		const query = generateQueryParams(params);
		return await this.get(`users/?${query}`);
	}
	async getUserDetails(id: string) {
		return await this.get(`users/${id}`)
	}
	async createUsers(parmas: { [key: string]: boolean | string | null }) {
		return await this.post('users', parmas)
	}
	async updateUsers(id: string, params: { [key: string]: boolean | string }) {
		return await this.put(`users/${id}`, params)
	}
	async deleteUsers(id: string) {
		return await this.delete(`users/${id}`)
	}
}
export const userService = new UserService();
